/*
 * @Descripttion: 设置 - 服务设置
 * @Author: hehua
 * @Date: 2024-01-26 17:45:02
 * @LastEditors: hehua
 * @LastEditTime: 2024-06-27 11:12:25
 */
const baseUrl = "api/drsp_elf";

export default {
  ///************************外部网点************************
  //批量切换网点类型
  customerUpdateBatch: {
    url: `${baseUrl}/customer/update/batch`,
    method: "post",
  },

  ///************************关联配置************************
  //获取服务商工单配置信息
  getConfigOrderInfo: {
    url: `${baseUrl}/provider/config/order/info`,
    method: "get",
  },
  //设置服务商工单配置信息
  setConfigOrderInfo: {
    url: `${baseUrl}/provider/config/order/setting`,
    method: "post",
  },
  // //获取网点列表
  getProviderChildPageAPI: { url: `${baseUrl}/provider/page`, method: "post" },
  //删除网点
  providerDelete: { url: `${baseUrl}/provider/delete`, method: "post" },

  ///************************备案申请************************
  //获取网点员工列表  不分页
  getEmployeeList: {
    url: `${baseUrl}/provider/employee`,
    method: "get",
    isParam: true,
  },
  //获取网点员工详情
  getEmployeeDetail: {
    url: `${baseUrl}/provider`,
    method: "get",
    isParam: true,
  },
  //分页查询备案申请的记录列表
  getRecordApplyPage: {
    url: `${baseUrl}/provider/employee/record_apply/page`,
    method: "post",
  },
  //获取员工审核申请结果列表
  getRecordApplyEmployee: {
    url: `${baseUrl}/provider/employee/record_apply`,
    method: "get",
    isParam: true,
  },
  //员工备案申请操作
  employeeApply: { url: `${baseUrl}/provider/employee/apply`, method: "post" },

  ///************************时效设置************************
  //获取时效设置
  getTimelinessConfig: {
    url: `${baseUrl}/order/timeliness/config/list`,
    method: "post",
  },
  //设置时效设置
  setTimelinessConfig: {
    url: `${baseUrl}/order/timeliness/config/setting`,
    method: "post",
  },
  //获取众包配置信息
  getCrowdSourcingConfig: {
    url: `${baseUrl}/provider/config/crowd_sourcing/info`,
    method: "get",
  },
  //设置众包配置信息
  setCrowdSourcingConfig: {
    url: `${baseUrl}/provider/config/crowd_sourcing/setting`,
    method: "post",
  },

  ///************************交付管理************************
  // 分页查询交付方案
  getDeliveryPlanConfigPage: {
    url: `${baseUrl}/delivery/plan/config/page`,
    method: "post",
  },
  // 查询交付方案配置列表
  getDeliveryPlanConfigList: {
    url: `${baseUrl}/delivery/plan/config/list`,
    method: "post",
  },
  // 查询交付方案配置项列表
  getDeliveryPlanConfigItemList: {
    url: `${baseUrl}/delivery/plan/config/itm/list`,
    method: "post",
  },
  // 查询交付方案配置信息
  getDeliveryPlanConfigInfo: {
    url: `${baseUrl}/delivery/plan/config/info`,
    method: "get",
  },
  // 删除交付方案
  deleteDeliveryPlanConfig: {
    url: `${baseUrl}/delivery/plan/config/delete`,
    method: "get",
  },
  // 获取服务场景
  getServiceSceneList: {
    url: `${baseUrl}/serviceScene/list`,
    method: "post",
  },
  // 新增交付方案
  createDeliveryPlanConfig: {
    url: `${baseUrl}/delivery/plan/config/create`,
    method: "post",
  },
  // 修改交付方案
  modifyDeliveryPlanConfig: {
    url: `${baseUrl}/delivery/plan/config/modify`,
    method: "post",
  },
  // 复制交付方案
  copyDeliveryPlanConfig: {
    url: `${baseUrl}/delivery/plan/config/copy`,
    method: "post",
  },
  // 切换交付方案启用状态
  switchDeliveryPlanConfigEnable: {
    url: `${baseUrl}/delivery/plan/config/enable/switch`,
    method: "post",
  },
};
